const cashModal = (state = false, action) => {
    switch(action.type) {
        case 'cashModal':
            return action.payload;
        default:
            return state;
    }
}

export default cashModal;